import React from 'react';
import WetLabLogic from './WetLabLogic';
/**
 * Display for WetLab components.
 * @return {WetLab}
 */
function WetLabPage() {
  return (
    <div className='centerScreen'>
      <div className='centerPart'>
        <WetLabLogic/>
      </div>
    </div>
  );
}

export default WetLabPage;
